import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[2],
        fontSize: 11,
        maxHeight: 300,
        overflowY: 'auto',
    },
}));

type Props = Omit<TooltipProps, 'title' | 'children' | 'style'> & {
    title: string;
    children: React.ReactElement;
    style?: React.CSSProperties;
};

export default function CustomizedTooltip({ title, children, style, ...rest }: Props) {
    return (
        <LightTooltip
            title={<span dangerouslySetInnerHTML={{ __html: title }} />}
            style={{ ...style }}
            {...rest}
        >
            {children}
        </LightTooltip>
    );
}
